"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = __importDefault(require("./constants"));

var splitByIndex_1 = __importDefault(require("./helpers/splitByIndex"));

exports.default = function (unformatted, formatShape) {
  if (!formatShape) return unformatted;

  switch (formatShape) {
    case "dashed":
      return "+(".concat(constants_1.default.prefix, ")-").concat(splitByIndex_1.default(unformatted, 3, "dash"));

    case "dashed-short":
      return "".concat(splitByIndex_1.default(unformatted, 3, "dash"));

    case "dashed-normalized":
      return "0".concat(splitByIndex_1.default(unformatted, 3, "dash"));

    case "dashed-unformatted":
      return "".concat(constants_1.default.prefix, "-").concat(splitByIndex_1.default(unformatted, 3, "dash"));

    case "space":
      return "+(".concat(constants_1.default.prefix, ") ").concat(splitByIndex_1.default(unformatted, 3, "space"));

    case "space-short":
      return "".concat(splitByIndex_1.default(unformatted, 3, "space"));

    case "space-normalized":
      return "0".concat(splitByIndex_1.default(unformatted, 3, "space"));

    case "space-unformatted":
      return "".concat(constants_1.default.prefix, " ").concat(splitByIndex_1.default(unformatted, 3, "space"));

    case "normalized":
      return "0".concat(unformatted);

    case "unformatted":
      return "250".concat(unformatted);

    case "short":
      return unformatted;

    default:
      return "";
  }
};